import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const TaskIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 3C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V11.4941C21 10.6985 20.6839 9.93543 20.1213 9.37282L14.6272 3.87868C14.0646 3.31607 13.3015 3 12.5059 3H6ZM4.2 6C4.2 5.00589 5.00589 4.2 6 4.2H12.4V9.00002C12.4 10.436 13.5641 11.6 15 11.6H19.8V18C19.8 18.9941 18.9941 19.8 18 19.8H6C5.00589 19.8 4.2 18.9941 4.2 18V6ZM19.4293 10.4C19.3814 10.3374 19.3292 10.2777 19.2728 10.2213L13.7787 4.72721C13.7223 4.67085 13.6626 4.6186 13.6 4.57068V9.00002C13.6 9.77322 14.2268 10.4 15 10.4H19.4293Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

TaskIcon.propTypes = iconPropTypes;
TaskIcon.defaultProps = iconDefaultProps;
